export default "__VITE_ASSET__3aZtEhCw__"